import { DateTime } from 'luxon'
export const convertTimestampToVisible = (timestamp: string) => {
    const dt = DateTime.fromISO(timestamp)
    return dt.toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS)
}
